/**
 * downloadJson — browser-side JSON file download (object URL + anchor click).
 * Extracted from SettingsDataPage (W4, 2026-08-11) so the staff POPIA export
 * on the admin customer page reuses it instead of growing a duplicate
 * (pre-flight rule: search shared/utils before writing a helper).
 */
export function downloadJson(filename: string, payload: unknown): void {
  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: 'application/json;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
